module.exports = __webpack_public_path__ + "img/9.b4556c64.jpg";